// @ts-nocheck
import componentsReducer, { ComponentsActions } from "@store/Framework/Store/Starter/Components/ComponentsReducer";
import pagesReducer, { PagesActions } from "@store/Framework/Store/Starter/Pages/PagesReducer";
import { combineReducers } from "redux";

const starterReducer = combineReducers({
    components: componentsReducer,
    pages: pagesReducer,
});

export type StarterActions = ComponentsActions | PagesActions;

export default starterReducer;
